import { render, staticRenderFns } from "./booklet-bloks.vue?vue&type=template&id=1899f603&scoped=true"
import script from "./booklet-bloks.vue?vue&type=script&lang=ts"
export * from "./booklet-bloks.vue?vue&type=script&lang=ts"
import style0 from "./booklet-bloks.vue?vue&type=style&index=0&id=1899f603&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1899f603",
  null
  
)

export default component.exports